import globals from "./globals";
import $ from "cash-dom";

const component = (function () {
    function fitProportionally(_el, _parent) {
        var elementRatio = _el.clientWidth / _el.clientHeight;
        var parentRatio = _parent.clientWidth / _parent.clientHeight;
        var isVertical = window.innerHeight > window.innerWidth;
        var caption = $(_parent).find(".dynamic-caption")[0];
        var scrollIndicator = $(_parent).find(".scroll-indicator")[0];
        var conditionMet =
            ($(_el).hasClass("fit-proportionally") && !$(_el).hasClass("ver:fill-proportionally")) ||
            ($(_el).hasClass("fit-proportionally") && $(_el).hasClass("ver:fill-proportionally") && !isVertical) ||
            ($(_el).hasClass("ver:fit-proportionally") && isVertical);
        if (conditionMet) {
            if (elementRatio >= parentRatio) {
                _el.style.width = "100%";
                _el.style.height = "auto";
            } else {
                _el.style.width = "auto";
                _el.style.height = "100%";
            }
            var offsetX = (_parent.clientWidth - _el.clientWidth) / 2;
            var offsetY = (_parent.clientHeight - _el.clientHeight) / 2;
            _el.style.top = `${offsetY}px`;
            _el.style.left = `${offsetX}px`;

            caption.style.bottom = `${offsetY}px`;
            caption.style.left = `${offsetX}px`;
            caption.style.right = `${offsetX}px`;
            scrollIndicator.style.top = `${offsetY}px`;
            scrollIndicator.style.left = `${offsetX}px`;
            scrollIndicator.style.right = `${offsetX}px`;
        }
    }
    $(window).on("load", function () {
        if ($(".fit-proportionally, .ver\\:fit-proportionally").length) {
            if (globals.debug) console.log("component-fit-proportionally initialized");
            $(".fit-proportionally, .ver\\:fit-proportionally").each(function () {
                var el = $(this)[0];
                var parent = $(this).parent()[0];
                parent.style.position = "relative";
                el.style.position = "absolute";
                fitProportionally(el, parent);
            });
            $(window).on("resizeEnd", function () {
                $(".fit-proportionally, .ver\\:fit-proportionally").each(function () {
                    var el = $(this)[0];
                    var parent = $(this).parent()[0];
                    fitProportionally(el, parent);
                });
            });
        }
    });
})();
export default component;
